/**
 * Validate if product URL already exists or not
 * @param url
 * @param id
 * @param products
 * @returns {boolean}
 */
export const validProductUrl = (url, id, products) => {
  return !products.some((product) => product.url === url && id !== product.id);
};

/**
 * Validate if product ID already exists or not
 * @param id
 * @param products
 * @returns {boolean}
 */
export const validProductId = (id, products, currentProductId) => {
  if (!!currentProductId) return !products.some((product) => product.id !== currentProductId && product.id === id);
  else return !products.some((product) => product.id === id);
};
